import { MapRessource } from '@/framework/base/helpers/Ressources';

export default class Fiche {
  // eslint-disable-next-line
  public component: any;
  public type: string;
  // eslint-disable-next-line
  public data: any;
  public readonly: boolean;
  public ressourceHeader: MapRessource | null;
  public showSection: boolean;
 }
